import { Flex } from 'antd';
import { useTranslation } from 'react-i18next';
import { spacing } from '../../theming';
import { labelStyle, monoTextStyle } from './vinExtractionStyles';
import NoValue from './NoValue';

/** The model the attempt ran on; a legacy attempt without one says so. */
const AttemptModel = ({ model }) => {
    const { t } = useTranslation('vinExtraction');

    return (
        <Flex gap={spacing[1]} align="baseline">
            <span style={labelStyle}>{t('drawer.attempt.model')}</span>
            {model ? <span style={monoTextStyle}>{model}</span> : <NoValue label={t('drawer.attempt.noModel')} />}
        </Flex>
    );
};

export default AttemptModel;
